import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const Modals = ({ isOpen, handleClose, contentLabel, children }) => {

    const customStyles = {
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
    };
    return (
        <Modal
            style={customStyles}
            isOpen={isOpen}
            contentLabel={contentLabel}
            className="modal z-50"
            overlayClassName="overlay"
            ariaHideApp={false}
        >
            <button
                onClick={handleClose}
                className="absolute top-[30px] right-[30px] text-[#C8960C] text-center bg-[#1A1400] border border-[#3D2D00] h-[40px] w-[40px] rounded-full hover:text-[#FFD700] hover:border-[#C8960C] text-xl transition-colors"
            >
                &times;
            </button>
            <div className="p-5 bg-[#0D0D0D] rounded-lg border border-[#3D2D00]">
                {children}
            </div>
        </Modal>
    );
};

export default Modals;
